function Footer() {
  return (
    <div className="flex items-center justify-end bg-footer-background px-[20px] py-[5px]">
      <span className="whitespace-nowrap text-[0.6875rem] text-footer-color/70">
        © {new Date().getFullYear()} Atica Global
      </span>
    </div>
  );
}

export default Footer;
